/* eslint-disable @typescript-eslint/no-explicit-any */
import { envConfig } from "@/libs/env-config";

export const buildQueryString = (
  params: Record<string, string | number | boolean | null | undefined>
): string => {
  // Return empty string for null, undefined, or non-object params
  if (!params || typeof params !== "object") {
    return "";
  }

  // Filter out null and undefined values, then build query string
  const validParams = Object.entries(params)
    .filter(([_, value]) => value !== null && value !== undefined)
    .map(([key, value]) => {
      // Ensure proper encoding of both key and value
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value));
      return `${encodedKey}=${encodedValue}`;
    })
    .join("&");

  // Only add the ? prefix if we have parameters
  return validParams ? `?${validParams}` : "";
};
const getCookieValue = (name: string): string | null => {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp("(^| )" + name + "=([^;]+)")
  );
  return match ? decodeURIComponent(match[2]) : null;
};
export const handleApiError = <T>(error: any, context: string, defaultValue?: T): T => {
  console.error(`API Error (${context}):`, error);
  // Return a default value instead of throwing
  return defaultValue as T;
};

export const getCommonHeaders = () => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  // Add merchant ID from environment config
  if (envConfig.gokwik.mid) {
    headers.append("gk-merchant-id", envConfig.gokwik.mid);
  }

  // Add access token from environment config
  
  // if (envConfig.kwikpass.userToken) {
  //   const userCoreToken = getCookieValue(envConfig.kwikpass.userToken)
  //   headers.append("gk-access-token", userCoreToken || "");
  // }

  

  // Read request ID from cookies if available
  const kpRequestId = getCookieValue("kp-request-id");
  if (kpRequestId) {
    headers.append("Gk-Request-Id", kpRequestId);
    headers.append("Kp-Request-Id", kpRequestId);
  }

  return headers;
};
